import { ProjetoService } from 'src/app/projeto/projeto.service';
import { Component, ViewChild, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SwalComponent } from '@toverux/ngx-sweetalert2';
import { NgbModal, NgbModalRef  } from '@ng-bootstrap/ng-bootstrap';
@Component({
	selector: 'app-form-projeto-meta',
  	templateUrl: './form-projeto-meta.component.html',
  	styleUrls: ['./form-projeto-meta.component.scss']
})
export class FormProjetoMetaComponent{
	@ViewChild('Swal') public swal:SwalComponent;
	@ViewChild('SwalDelete') public swalDelete:SwalComponent; 
	@Input() projetosMetas = new Array();
	@Input() pessoa_id: number;
	@Input() acao:string;
	@Input() stakeholdersSelect = new Array();
	@Input() detalhe: boolean;
	create:boolean;
	edit:boolean;
	detail:boolean;
	delete:boolean;
	modalDetalhe:boolean = false;
	form: FormGroup;
	projeto_meta_id:number = null;
	modalTitle:string;
	submitted: boolean = false;
	loading: boolean = false;
	modalReference: NgbModalRef; 
	constructor(private projetoService: ProjetoService, private formBuilder: FormBuilder, private modalService: NgbModal, private activatedRoute: ActivatedRoute){
		

        this.form = this.formBuilder.group({
			tipo: this.formBuilder.control('',[Validators.required]),
			descricao: this.formBuilder.control('',[Validators.required]),
			quantidade: this.formBuilder.control('',[Validators.required]),
			alcancada: this.formBuilder.control(''),
		})

		
	}

	ngOnInit(){ 
		let t = JSON.parse(localStorage.getItem('CONFLogin'));
		if(t.permissao.projeto_meta.includes("CONSULTAR"))
			this.detail = true;
		if(t.permissao.projeto_meta.includes("CRIAR"))
			this.create = true;
		if(t.permissao.projeto_meta.includes("EDITAR"))
			this.edit = true;
		if(t.permissao.projeto_meta.includes("EXCLUIR"))
			this.delete = true;

		
	}
	
	onSubmit(){
		this.submitted = true;
        if(!this.form.valid)
		return;
		this.modalReference.close();
		if(!this.projeto_meta_id){
			this.projetoService.addProjetoMeta(this.activatedRoute.snapshot.params['id'], this.form)
			.subscribe( (success) => {
				this.swal.text = "Meta cadastrada com sucesso!";
				this.swal.type = "success";
				this.swal.title = "Pronto!";
				this.swal.show();
				this.submitted = false;
				this.zeraForm();
			},
			(error) => {
				this.swal.text = error.error.message;
				this.swal.type = "error";
				this.swal.title = "Erro!";
				this.swal.show();
				this.submitted = false;
			});
			return;
		}

		this.projetoService.editProjetoMeta(this.projeto_meta_id,this.form)
			.subscribe( (success) => {
				this.swal.text = "Meta atualizada com sucesso!";
				this.swal.type = "success";
				this.swal.title = "Pronto!";
				this.swal.show();
				this.submitted = false;
				this.zeraForm();
			},
			(error) => {
				this.swal.text = error.error.message;
				this.swal.type = "error";
				this.swal.title = "Erro!";
				this.swal.show();
				this.submitted = false;
				this.zeraForm();
			});
	}
	zeraForm(): void {
		this.form.patchValue({
			tipo: '',
			descricao: '',
			quantidade: '',
			alcancada: '',
		});
	}

	openModal(modal,id:number = null,detalhe:boolean = false) {
		this.modalDetalhe = detalhe;
		//Se id == null então é cadastro.
		if(!id){
			this.projeto_meta_id = null;
			this.modalTitle = "Cadastrar Meta";
			this.modalReference = this.modalService.open(modal,{size: 'lg', backdrop: 'static' });
			return;
		}
		
		//Senão é edição.
		this.projeto_meta_id = id;
		this.modalTitle = "Editar Meta";
		this.projetoService.getProjetoMetaById(id).subscribe((success) => {
			this.form.patchValue({
				tipo: success.dados.tipo,
				descricao: success.dados.descricao,
				quantidade: success.dados.quantidade,
				alcancada: success.dados.alcancada,
			});
			this.modalReference = this.modalService.open(modal,{size: 'lg', backdrop: 'static' });
		},
		(error) => {
			this.swal.text = error.error.message;
			this.swal.type = "error";
			this.swal.title = "Erro!";
			this.swal.show();
		})
	}

	askDelete(id:number){
		this.projeto_meta_id = id;
		this.swalDelete.show();
	}

	confirmDelete(){
		this.projetoService.delProjetoMeta(this.projeto_meta_id).subscribe( 
		(success) => {
			this.swal.text = "Meta deletada com sucesso!";
			this.swal.type = "success";
			this.swal.title = "Pronto!";
			this.swal.show();
			this.submitted = false;
		},
		(error) => {
			this.swal.text = error.error.message;
			this.swal.type = "error";
			this.swal.title = "Erro!";
			this.swal.show();
			this.submitted = false;
		});
	}

	onCloseModal(){
		if(this.swal.type == "success"){
			this.projetoService.getProjetoById(this.activatedRoute.snapshot.params['id']).subscribe((success)=>{
				this.projetosMetas = success.dados.meta;
				this.submitted = false;
			},
			(error) => {
				this.swal.text = error.error.message;
				this.swal.type = "error";
				this.swal.title = "Erro!";
				this.swal.show();
				this.submitted = false;
			});
		}
	}
}